import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface PartyCategoryMasterState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allPartyCategoryMasterList: any[];
}

const initialState: PartyCategoryMasterState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allPartyCategoryMasterList: [],
};

export const partyCategoryMasterSlice = createSlice({
  name: "partyCategoryMaster",
  initialState,
  reducers: {
    setPartyCategoryMaster: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setPartyCategoryMasterBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllPartyCategoryMaster: (state, action) => {
      state.allPartyCategoryMasterList = action.payload.data;
    },
    reset: () => initialState,
  },
});

export const {
  setPartyCategoryMaster,
  setPartyCategoryMasterBySearch,
  setAllPartyCategoryMaster,
  reset,
} = partyCategoryMasterSlice.actions;

// Selectors
export const getPartyCategoryMasterDetails = (state: RootState) =>
  state.partyCategoryMaster.data;

export const getPartyCategoryMasterBySearchDetails = (state: RootState) =>
  state.partyCategoryMaster.data;

export const getPartyCategoryTotalRecords = (state: RootState) =>
  state.partyCategoryMaster.totalRecords;

export const getPartyCategoryMasterList = (state: RootState) =>
  state.partyCategoryMaster.allPartyCategoryMasterList;

export const getPartyCategoryMasterListWithAll = (state: RootState) => [
  {
    id: 0,
    code: "ALL",
    name: "All",
    description: "All Categories",
    isActive: true,
  },
  ...(state.partyCategoryMaster.allPartyCategoryMasterList || []),
];

export default partyCategoryMasterSlice.reducer;
